var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"loading"},[_c('div',{staticClass:"loading-container"},[_vm._m(0),_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-box"},[_c('div',{staticClass:"loading-bubble-1"}),_c('div',{staticClass:"loading-bubble-2"})])
}]

export { render, staticRenderFns }